import {
    IPortfolioItemFragment,
    IPortfolioTrainingListItemFragment,
    IContentTypeValue,
    ISkillDetailFragment,
    IPortfolioItemSyncStatus,
} from 'graphql/types';

// Type guard to check if the related object is a training list item
export const isTrainingPortfolioItem = (
    relatedObject: IPortfolioItemFragment['relatedObject'],
    relatedType: IPortfolioItemFragment['relatedType']
): relatedObject is IPortfolioTrainingListItemFragment =>
    relatedType === IContentTypeValue.Training;

export const isSkillPortfolioItem = (
    relatedObject: IPortfolioItemFragment['relatedObject'],
    relatedType: IPortfolioItemFragment['relatedType']
): relatedObject is ISkillDetailFragment =>
    relatedType === IContentTypeValue.Skill;

export const getPortfolioItemSyncStatusTransKey = (
    status: IPortfolioItemSyncStatus
) => {
    switch (status) {
        case IPortfolioItemSyncStatus.Success:
            return 'portfolioItemSyncStatus.success';
        case IPortfolioItemSyncStatus.Failed:
            return 'portfolioItemSyncStatus.failed';
        case IPortfolioItemSyncStatus.Busy:
            return 'portfolioItemSyncStatus.busy';
        default:
            return 'portfolioItemSyncStatus.initial';
    }
};
